module.exports = "/static/media/icon-note-pinned.c208d1cd.svg";